{
  "version": 1,
  "asset_id": "e1a04cc6-4f1e-4a09-bfb9-d7bdc11f813a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e1a04cc6-4f1e-4a09-bfb9-d7bdc11f813a/blog-default-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e1a04cc6-4f1e-4a09-bfb9-d7bdc11f813a/blog-default-1280.avif",
  "original_filename": "blog-default-1280.avif",
  "size": 72896,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:51Z"
}
